<template>
	<v-row>
		<v-col>
			<base-material-card color="success" class="px-5 py-3">
				<template #heading>
					<div class="d-flex">
						<div class="text-h3 font-weight-light">
							Projects
						</div>
						<v-spacer/>
						<div class="text-left">
							<v-btn :to="{ name: 'project-create' }">
								Create
							</v-btn>
						</div>
					</div>
				</template>
				<v-card-text>
					<v-data-table :headers="headers" :items="projects"
												:items-per-page="20"
												:options.sync="options"
												:sort-by.sync="options.sortBy"
												:sort-desc.sync="options.sortDesc"
												:footer-props="{
        												itemsPerPageOptions: [10,20,50,-1]
      									}"

					>
						<template #item.link="{item}">
							<a :href="item.link" target="_blank">{{ item.link }}</a>
						</template>
						<template #item.actions="{ item }">
							<router-link
								:to="{ name: 'project-multi-edit', params: { id: item.id } }"
							>
								<v-icon small class="mr-2">
									mdi-eye
								</v-icon>
							</router-link>
							<v-icon small @click="deleteProject(item)">
								mdi-delete
							</v-icon>
						</template>
					</v-data-table>
				</v-card-text>
			</base-material-card>
		</v-col>
	</v-row>
</template>

<script>
import {types} from "@/store/modules/Project.module";

export default {
	name: "ProjectsView",
	props: {},
	data() {
		return {
			headers: [
				{text: "subject", value: "subject"},
				{text: "created_at", value: "created_at"},
				{text: "link", value: "link"},
				{text: "actions", value: "actions"}
			],
			options: {
				sortBy: ['created_at'],  // מיון לפי עמודת createdAt
				sortDesc: [true],       // מיון בסדר יורד (מהחדש לישן)
				itemsPerPage: 5
			}
		};
	},
	computed: {
		projects() {
			return this.$store.state.ProjectModule.projects;
		}
	},
	created() {
		this.$store.dispatch(types.FETCH);
	},
	methods: {
		deleteProject(project) {
			this.$notfication.warning().then(data => {
				if (data.isConfirmed) {
					this.$store.dispatch(types.REMOVE, project).then(response => {
						this.$notfication.success();
					});
				}
			});
		},
		pageCount(p) {
		}
	}
};
</script>

<style scoped></style>
